export const handleTextToHtml = (text) => {
    const tagMap = {
        _b_: '<span class="bold">',
        _bi_: '<span class="bold italic">',
        _biu_: '<span class="bold italic underline">',
        _i_: '<span class="italic">',
        _s_: '<span class="strikethrought">',
        _u_: '<span class="underline">',
    };
    let editedText = text;
    // Thay thế tất cả các tag theo thứ tự
    Object.entries(tagMap).forEach(([key, value]) => {
        let index = 0;
        editedText = editedText.replace(new RegExp(key, 'g'), () => {
            const replacement = index % 2 === 0 ? value : '</span>';
            index++;
            return replacement;
        });
    });
    return editedText;
};
